import React from "react";

const PotencialesClientes = () => {
  return (
    <>
      <div className="info">
        <p>
          {" "}
          En el contexto del marketing, un lead es un “comprador potencial”.
          Nosotros nos encargamos de captarlos a través de internet utilizando
          las herramientas mas efectivas como Google Adwords, Facebook, y
          campañas de Email Marketing. Planificamos y diseñamos las mejores
          estrategias obteniendo así Leads efectivos.Generamos potenciales
          clientes para su empresa obteniendo tráfico a través de: Google,
          Facebook, Gmail, Redes Sociales e Email marketing.
        </p>
        <ul>
          <li>Son datos generados en el momento.</li>
          <li>Son los datos más completos del mercado.</li>
          <li>Son datos con alto porcentaje de cierre.</li>
          <li>Son datos segmentados por GBA / Interior.</li>
          <li>Son datos únicos que solo tendrá su concesionaria.</li>
        </ul>
      </div>
      <div className="table">
        <div>
          <h4>¿Por qué hacemos esta propuesta?</h4>
          <p>
            Queremos ser proveedores de su Negocio a fin de que ambos podamos
            aprovechar la fabulosa oportunidad que está brindando el mercado en
            Internet. Actualmente tenemos gran capacidad de poder venderle datos
            de interesados en adquirir su producto.
          </p>
        </div>
        <div>
          <h4> ¿De dónde obtenemos nuestros Leads?</h4>
          <p>
            Obtenemos Leads desde Sitios Web especialmente diseñados para que
            tengan un alto porcentaje de conversión. Ofrecemos diferentes
            alternativas de datos entre ellos datos de redes sociales, adwords,
            SMS, MMS.
          </p>
        </div>
        <div>
          <h4> ¿Cómo es la metodología de trabajo?</h4>
          <p>
            Acordamos una cantidad mensual de leads. Día a día le entregamos
            leads a sus vendedores. Realizamos envíos diarios equitativamente a
            la cantidad mensual. A fin de mes entregamos el informe mensual y el
            listado de leads entregados.
          </p>
        </div>{" "}
      </div>
    </>
  );
};

export default PotencialesClientes;
